import React, { useEffect, useRef, useState } from 'react'
import { useGetEventUserQuery } from '../../api/eventUser.api'
import { useMyContext } from '../../context/context'
import InputRadioCheckbox from '../../shared/form/input.radio.checkbox'
import { getDate } from '../../utils/date'
import { useGetArticlesQuery } from '../../api/article.api'
import useConf from '../../hooks/useConf'
import HTML from '../../components/HTML'
import { useSteps } from './Steps'
import useSettingsV2 from '../../hooks/useSettingsV2'

const Dates = () => {
  const [daysId, setDaysId] = useState([])
  // L'auto-saut ne doit partir qu'UNE fois par montage. Sans ce garde, il repartait quand
  // `eventUser` se re-fetchait (invalidation du cache après l'écriture de la typo) → un second
  // nextStep() faisait dépasser l'index et sautait l'étape Articles. `daysId` a aussi été retiré
  // des deps de l'effet (il n'y est pas utilisé et servait uniquement de re-déclencheur parasite).
  const skipped = useRef(false)

  const { event, myContext } = useMyContext()
  const { settings } = useSettingsV2()
  const { nextStep, userId, NextButton, CompanionName, setDaysId: setDaysId2, settling } = useSteps()
  const { datesHide } = useConf()

  const { data: eventUser } = useGetEventUserQuery({ ...myContext, userId })
  const { data: articles } = useGetArticlesQuery(myContext)

  useEffect(() => {
    if (skipped.current) return
    // On NE saute PAS tant que la nav se stabilise (typo → settings en cours de re-fetch) : sinon
    // on dépasserait l'étape Articles qui n'est pas encore insérée. `settling` étant dans les deps,
    // l'effet re-tourne dès qu'il repasse à false, et le saut part alors sur le tableau à jour.
    if (settling) return
    if (Array.isArray(event.days)) {
      if (event.days.length <= 1 || datesHide) {
        skipped.current = true
        setDaysId2(event.days.map(m => m.id))
        nextStep()
      }
    }
  }, [datesHide, event, nextStep, setDaysId2, settling])

  useEffect(() => {
    if (Array.isArray(event.days) && event.days.length > 1) {
      if (eventUser?.UserEvent) {
        setDaysId(eventUser?.UserEvent?.UserEventDays?.filter(ued => ued.registered)?.map(ued => ued.eventDayId))
      }
    }
  }, [event, eventUser])

  if (event.days.length <= 1) {
    return null
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <HTML name="FO_MEETING_DATES_HTML" />
      {CompanionName}
      <InputRadioCheckbox
        label={
          <div
            dangerouslySetInnerHTML={{
              __html: settings?.FO_MEETING_DATES_TITLE?.replace(/\n/g, '<br/>') || "Je souhaite m'inscrire pour \n les dates suivantes :",
            }}
          />
        }
        style={{ textAlign: 'center', marginBottom: 10 }}
        options={
          event?.days.map(ed => {
            const p = articles?.reduce((prev, curr) => {
              const isSelected = curr.days?.[ed.id]?.isSelected
              if (isSelected) {
                return prev + curr.price
              }
              return prev
            }, 0)
            return {
              label: `${getDate(ed.day)} ${p ? `(${p} € H.T.)` : ''}`,
              value: ed.id.toString(),
            }
          }) || []
        }
        selectedValues={daysId.map(d => d.toString())}
        type="checkbox"
        setSelectedValue={v => {
          const dayId = Number(v)
          const find = daysId.find(d => d === dayId)
          if (find) setDaysId(daysId.filter(d => d !== dayId))
          else setDaysId([...daysId, dayId])
        }}
      />
      <NextButton
        onClick={async () => {
          setDaysId2(daysId)
          nextStep()
        }}
        disabled={daysId.length < 1}
      />
    </div>
  )
}

export default Dates
